var TrackerItem;
(function (TrackerItem) {
    TrackerItem["MultimediaMessageUpload"] = "imsdk_upload_msg";
    TrackerItem["InitHandler"] = "imsdk_init_handler";
    TrackerItem["Exception"] = "imsdk_exception";
    TrackerItem["SaveMessageError"] = "imsdk_save_msg_error";
    TrackerItem["IntegrityCheckConversation"] = "imsdk_puller_check_conv_and";
    TrackerItem["MessageAck"] = "imsdk_message_ack";
    // rtc
    TrackerItem["RtcStartCall"] = "imsdk_rtc_start_call";
    TrackerItem["RtcSwitch"] = "imsdk_rtc_switch";
    TrackerItem["RtcReceiveRing"] = "imsdk_rtc_receive_ring";
    TrackerItem["RtcAcceptCall"] = "imsdk_rtc_accept_call";
    TrackerItem["RtcDenyCall"] = "imsdk_rtc_deny_call";
    TrackerItem["RtcTerminate"] = "imsdk_rtc_terminate";
    TrackerItem["RtcEnd"] = "imsdk_rtc_end"; // 结束通话
})(TrackerItem || (TrackerItem = {}));

export { TrackerItem };
//# sourceMappingURL=trackerTypes.js.map
